export class HangHoa {
    HangHoaID: string;
    MaHH: string;
    SKU: string;
    TenHH: string;
    GiaBanLe: number;
    VATDauRa: number;
    HinhAnh?: boolean;
    checked?: boolean;
    MaNganh?: string;
    MaNhom?: string;
    MaPhanNhom?: string;
    MaNCC?: string;
    MaKhuVuc: string;
    DonViTinh: string = "EA";
}

export class optionSearch {
    id: number;
    name: string;
}

export class valueSearch {
    option: string;
    value: string;
}

export let optSearch: Array<optionSearch> = [
    {id: 1, name: 'UPC'},
    {id: 2, name: 'SKU'},
    {id: 3, name: 'Tên hàng hóa'}
]



// WEBPACK FOOTER //
// ./src/app/models/product.model.ts